<script>
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
// import axios from "axios";
// import Swal from "sweetalert2";
// import { defineAsyncComponent, ref } from "vue";
// import moment from "moment";



export default {
  page: {
    title: "Laporan Akreditasi",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
        title: "Laporan Akreditasi",

    };
  },
  mounted(){

  },
  methods: {
  },
};
</script>
<style>

</style>
<template>
    <Layout>
        <PageHeader :title="title"/>
    
    </Layout>
</template>
